import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PageLoader from "./PageLoader/PageLoader";

const ProtectedRoute = ({ element: Component, adminOnly = false, allowWithoutConsent = false, allowWithoutSubscription = false, ...rest }) => {
    const { isLoggedIn, isAdmin, isLoading, activeSubscription, needsConsents } = useAuth();
    const location = useLocation();

    // Wskaźnik tylko przy pierwszym sprawdzaniu logowania. Dostęp liczony od razu podczas renderu –
    // wcześniej był ustawiany w useEffect, przez co każde przejście między stronami pokazywało ekran ładowania.
    if (isLoading) {
        return <PageLoader />;
    }

    const isAuthorized = isLoggedIn && (!adminOnly || isAdmin);

    if (!isAuthorized) {
        return <Navigate to={isLoggedIn ? "/" : "/login"} state={isLoggedIn ? undefined : { from: location }} />;
    }

    if (!allowWithoutConsent && needsConsents) {
        return <Navigate to="/consents" replace />;
    }

    if (allowWithoutConsent && !needsConsents && location.pathname === '/consents') {
        return <Navigate to="/personForm" replace />;
    }

    if (!allowWithoutSubscription && !activeSubscription && !isAdmin) {
        return <Navigate to="/subscription-expired" replace />;
    }

    return <Component {...rest} />;
};

export default ProtectedRoute;
